export const printDocument = (url: string, type: "pdf" | "image") => {
  const iframe = document.createElement("iframe");
  Object.assign(iframe.style, {
    position: "fixed",
    right: "0",
    bottom: "0",
    width: "0",
    height: "0",
    border: "none",
  });

  const triggerPrint = () => {
    try {
      iframe.contentWindow?.focus();
      iframe.contentWindow?.print();
    } catch {
      window.open(url, "_blank");
    }
    setTimeout(() => iframe.remove(), 1000);
  };

  document.body.appendChild(iframe);

  if (type === "pdf") {
    iframe.onload = triggerPrint;
    iframe.src = url;
  } else {
    iframe.onload = () => {
      const img = iframe.contentDocument?.querySelector("img");
      if (img && !img.complete) {
        img.onload = triggerPrint;
      } else {
        triggerPrint();
      }
    };
    const doc = iframe.contentDocument;
    if (doc) {
      doc.open();
      doc.write(
        `<html><head><title>Print</title><style>html,body{margin:0;padding:0;}img{max-width:100%;display:block;margin:auto;}</style></head><body><img src="${url}" /></body></html>`
      );
      doc.close();
    }
  }
};